import { CalculatorIcon, IdentificationIcon } from '@heroicons/react/outline'
import { Autocomplete, Box, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PaymentSuccess from '../Controllers/PaymentSuccess'
import { addToCartProduct } from '../Redux/Action/catelog.action'
import { getAllCustomers } from '../Redux/Action/customer.action'
import { applyDiscount, placeOrder, removeDiscount, removeOrderInfo } from '../Redux/Action/order.action'
import { FormatAmount, GetCurrencySymbol } from './FormatAmount'
import PaymentRazor from './PaymentRazor'
import Popup from './Popup'

const PaymentDetails = ({ handleClosePopup, isSuccess, setIsSuccess }) => {
  const dispatch = useDispatch()
  const { extensionData } = useSelector((state) => state.extensionReducer)
  const { atcProduct } = useSelector((state) => state.catelogReducer)
  const { staffInfo, currency } = useSelector((state) => state.authReducer)
  const { allDiscount, discountInfo, ordeInfo, orderLoader } = useSelector((state) => state.orderReducer)
  const { allCustomers } = useSelector((state) => state.customerReducer)
  const currencyRate = currency && (currency?.find(c => c.name === staffInfo?.client?.currency_format)?.rate[0] ?? 1);
  const location_id = localStorage.getItem('location_id')
  const [selectCustomer, setSelectCustomer] = useState('')
  const [search, setSearch] = useState('')
  const [couponSearch, setCouponSearch] = useState('')
  const [selectCoupon, setSelectCoupon] = useState('')
  const [discountType, setDiscountType] = useState(atcProduct?.adjust_discount_type ?? '')
  const [adjustDiscount, setAdjustDiscount] = useState(atcProduct?.adjust_discount_percentage > 0
    ? atcProduct?.adjust_discount_percentage : (atcProduct?.adjust_discount * currencyRate) ?? '');
  const [cash, setCash] = useState(null);
  const [tab, setTab] = useState('Cash');
  const [orderData, setOrderData] = useState()
  const [isRazorPay, setIsRazorPay] = useState(false)
  const [razorPayData, setRazorPayData] = useState()
  const [razorPayKeyId, setRazorPayKeyId] = useState(null)
  const discountData = allDiscount?.data?.records && !atcProduct?.total_discount > 0 ? allDiscount?.data?.records : [];
  // useEffect(() => {
  //   if (extensionData)
  //     setRazorPayKeyId(extensionData?.data?.find((x) => x.secret_key === "key_id")?.secret_value)
  // }, [extensionData])

  useEffect(() => {
    if (atcProduct?.cash_amount && currencyRate) {
      setCash(atcProduct?.cash_amount * currencyRate);
    }
  }, [atcProduct, currencyRate]);
  const filterOptionsForCustomers = (options, { inputValue }) => {
    const normalizedInputValue = inputValue.toLowerCase();
    if (normalizedInputValue?.length < 3) {
      return []; // No options displayed until at least 3 characters are entered
    }
    return options?.filter((option) => {
      const combinedFields = `${option?.name?.toLowerCase() || ''} ${option?.phone?.toLowerCase() || ''} ${option?.email?.toLowerCase() || ''}`;
      return combinedFields.includes(normalizedInputValue);
    });
  };
  const paymentClose = () => {
    setIsSuccess(false);
  }

  useEffect(() => {
    loadScript('https://checkout.razorpay.com/v1/checkout.js');
  }, [])

  useEffect(() => {
    if (extensionData.length > 0) {
      const razorpayExtension = extensionData.find(
        (ext) => ext.extension_slug_name === "razorpay",
      );
      const razorpayKey = razorpayExtension?.data?.find((x) => x.secret_key === "key_id")?.secret_value;
      setRazorPayKeyId(razorpayKey ? razorpayKey : null);
    }
  }, [extensionData]);

  const handleCustomer = (e, v) => {
    const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
      products: [],
      status: 'completed',
      channel: 'pos',
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
    };

    let updateCart;

    if (!v?._id) {
      if (cart?.pos_membership_discount) {
        const { pos_customer, pos_membership_discount_type, pos_membership_discount_percentage, pos_membership_product, pos_membership_discount, pos_membership, ...restOfCart } = cart;
        updateCart = {
          ...restOfCart,
          total_price: cart?.total_price + pos_membership_discount,
          cash_amount: cart?.total_price + pos_membership_discount
        };
      } else {
        const { pos_customer, ...restOfCart } = cart;
        updateCart = {
          ...restOfCart,
        };
      }
      setSelectCustomer('')
    } else {
      setSelectCustomer(v?._id);
      if (v?.pos_membership && new Date(v?.expire_date) >= new Date()) {
        const calculateMembershipDiscount = () => {
          if (!v?.pos_membership) {
            return 0;
          }
          const membershipType = v?.pos_membership.product_discount_type;
          const membershipValue = v?.pos_membership.discount_value;

          if (membershipType === "percentage") {
            return cart?.sub_total * (membershipValue / 100);
          } else if (membershipType === "amount") {
            return membershipValue / currencyRate;
          }

          return 0;
        };
        const membershipDisc = calculateMembershipDiscount()
        updateCart = {
          ...cart,
          pos_customer: v?._id,
          pos_membership: v?.pos_membership?._id,
          pos_membership_product: v?.product_name,
          total_price: cart?.total_price - membershipDisc,
          cash_amount: cart?.total_price - membershipDisc,
          pos_membership_discount: membershipDisc,
          ...(v?.pos_membership?.product_discount_type === 'percentage' && { pos_membership_discount_percentage: v?.pos_membership.discount_value }),
          pos_membership_discount_type: v?.pos_membership?.product_discount_type
        };
      } else {
        updateCart = {
          ...cart,
          pos_customer: v?._id,
        };
      }
    }

    localStorage.setItem('addToCart', JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };
  const handleDiscount = (e, v) => {
    const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
      products: [],
      status: 'completed',
      channel: 'pos',
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
    };

    let updateCart;

    if (!v?.coupon_code) {
      const { total_discount, coupon_code, discount, ...restOfCart } = cart;
      updateCart = {
        ...restOfCart,
        total_price: cart?.sub_total - (cart?.adjust_discount || 0) - (cart?.pos_membership_discount || 0),
        cash_amount: cart?.sub_total - (cart?.adjust_discount || 0) - (cart?.pos_membership_discount || 0)
      };
      setSelectCoupon('');
      localStorage.setItem('addToCart', JSON.stringify(updateCart));
      dispatch(addToCartProduct(updateCart));
      dispatch(removeDiscount());
    } else {
      setSelectCoupon(v?.coupon_code);
    }
  };
  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  const placedOrder = () => {
    if (tab === 'UPI' || atcProduct?.split_payment) {
      setIsRazorPay(true);
      setRazorPayData(atcProduct);
    } else {
      const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
        products: [],
        status: 'completed',
        channel: 'pos',
        pos_location: location_id,
        total_price: 0,
        sub_total: 0,
      };
      const updateCart = {
        ...cart,
        cash_amount: cart?.total_price
      };
      dispatch(placeOrder(updateCart));
      handleClosePopup();
    }
  }
  const closeRazorpayPopup = () => {
    setIsRazorPay(false);
    setRazorPayData();
  }
  useEffect(() => {
    if (atcProduct?.pos_customer) {
      setSelectCustomer(atcProduct?.pos_customer);
    }
    if (atcProduct?.coupon_code) {
      setSelectCoupon(atcProduct?.coupon_code);
    }
  }, [atcProduct])

  useEffect(() => {
    if (!orderLoader && ordeInfo?.data?.status === 'completed') {
      setCash(null)
      setAdjustDiscount(null)
      setOrderData(ordeInfo);
      setIsSuccess(true);
      dispatch(removeOrderInfo());
    }
  }, [ordeInfo, orderLoader]);

  useEffect(() => {
    if (search === '' || search?.length > 2) {
      dispatch(getAllCustomers(search));
    }
  }, [search])
  const handleCashAmount = (e) => {
    if (Math.sign(e.target.value) === 1 || Math.sign(e.target.value) === 0) {
      setCash(e.target.value);
      const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
        products: [],
        status: 'completed',
        channel: 'pos',
        pos_location: location_id,
        total_price: 0,
        sub_total: 0,
      };
      let updateCart = { ...cart }
      if (cart?.split_payment) {
        if (e.target.value / currencyRate < cart.total_price) {
          updateCart = {
            ...cart,
            cash_amount: e.target.value / currencyRate,
            remaining_price: Math.abs(cart?.total_price - (e.target.value / currencyRate))
          };
        } else {
          return;
        }
      } else {
        if (e.target.value / currencyRate >= cart.total_price) {
          updateCart = {
            ...cart,
            cash_amount: e.target.value / currencyRate,
            change_amount: Math.abs(cart?.total_price - (e.target.value / currencyRate))
          };
        } else {
          updateCart = {
            ...cart,
            cash_amount: e.target.value / currencyRate,
            change_amount: 0
          };
        }
      }

      localStorage.setItem('addToCart', JSON.stringify(updateCart));
      dispatch(addToCartProduct(updateCart));
    }
  }
  const handleSplitOption = (e) => {
    const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
      products: [],
      status: 'completed',
      channel: 'pos',
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
    };
    let updateCart = { ...cart }
    if (e.target.checked) {
      if (cart?.cash_amount < cart.total_price) {
        updateCart = {
          ...cart,
          split_payment: e.target.checked,
          remaining_price: Math.abs(cart?.total_price - cart?.cash_amount)
        };
      } else {
        updateCart = {
          ...cart,
          split_payment: e.target.checked,
        };
      }
    } else {
      const { split_payment, remaining_price, ...restOfCart } = cart
      updateCart = {
        ...restOfCart,
      }
    }
    localStorage.setItem('addToCart', JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  }
  const discountOff = (e) => {
    // Retrieve the cart from localStorage or initialize a default cart
    const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
      products: [],
      status: 'completed',
      channel: 'pos',
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
      adjust_discount_type: discountType,
    };
    // Get the discount value from the input, defaulting to 0 if empty or NaN
    let discountValue = parseFloat(e.target.value) || 0;
    setAdjustDiscount(e.target.value);
    // Calculate percentage discount if applicable
    if (discountValue > 0 && discountType === 'percentage') {
      discountValue = (cart.sub_total - (cart.total_discount || 0)) * (discountValue / 100);
    } else if (discountValue > 0 && discountType === 'amount') {
      discountValue = discountValue / currencyRate;
    }
    let updateCart;

    // If discount input is cleared or 0, reset the discount and total price
    if (discountValue === 0) {
      updateCart = {
        ...cart,
        total_price: cart.sub_total - cart.total_discount || cart.sub_total, // Reset to sub_total minus total_discount
        adjust_discount: 0, // Remove the applied discount
        cash_amount: cart.sub_total - cart.total_discount || cart.sub_total,
      };
    } else {
      // Apply the discount if it's valid (greater than 0 and less than the original total price)
      if (discountValue > 0 && discountValue < cart.total_price) {
        updateCart = {
          ...cart,
          total_price: (cart?.sub_total - (cart?.total_discount || 0)) - discountValue, // Subtract discount from original total price
          adjust_discount: discountValue, // Track the applied discount
          adjust_discount_percentage: discountType === 'percentage' ? Number(e.target.value) : 0, // Track the applied discount
          cash_amount: (cart?.sub_total - (cart?.total_discount || 0)) - discountValue
        };
      } else {
        // Fallback when the discount is invalid (too large or negative)
        updateCart = {
          ...cart,
          total_price: cart.sub_total - cart.total_discount || cart.sub_total, // Reset to sub_total minus total_discount
          adjust_discount: 0, // Reset discount
          cash_amount: cart.sub_total - cart.total_discount || cart.sub_total,
        };
        cart.originalTotalPrice = 0; // Reset original total price if fallback is triggered
        setAdjustDiscount(0);
      }
    }

    // Save the updated cart to localStorage and update the state
    localStorage.setItem('addToCart', JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  };
  const handleDiscountType = (e) => {
    setDiscountType(e.target.value);
    setAdjustDiscount('')
    const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
      products: [],
      status: 'completed',
      channel: 'pos',
      pos_location: location_id,
      total_price: 0,
      sub_total: 0,
      total_discount: 0,
      adjust_discount: 0,
    };
    let updateCart
    const { adjust_discount_percentage, ...restOfCart } = cart
    updateCart = {
      ...restOfCart,
      total_price: cart?.sub_total - cart?.total_discount || 0,
      adjust_discount: 0,
      adjust_discount_type: e.target.value
    }
    localStorage.setItem('addToCart', JSON.stringify(updateCart));
    dispatch(addToCartProduct(updateCart));
  }
  return (
    <>
      <div className='p-5 sm:min-w-[460px] flex flex-col gap-4'>
        <div className='flex items-center justify-between'>
          <h4>Payment Details</h4>
        </div>
        <span className='text-[16px] block font-medium'>Customer Information</span>
        <div className='relative input'>
          <Autocomplete
            className="autocomplete"
            options={allCustomers?.records ?? []}
            getOptionLabel={(option) => option?.name || ''}
            filterOptions={filterOptionsForCustomers}
            value={allCustomers?.records?.find((x) => x._id === atcProduct?.pos_customer) || null}
            noOptionsText={
              allCustomers?.records?.length > 0 && !search
                ? 'Please enter at least 3 characters'
                : 'Not found'
            }
            onChange={handleCustomer}
            renderOption={(props, option) => (
              <Box key={option._id} component="li" {...props}>
                <div>
                  <p className="text-sm">{option.name}</p>
                  {option.phone ? <p className="text-sm">{option.phone}</p>
                    :
                    option.email && <p className="text-sm">{option.email}</p>}
                </div>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Customer"
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                onChange={(e) => {
                  const newInputValue = e.target.value;
                  if (typeof newInputValue === 'string' && newInputValue.length >= 3) {
                    setSearch(newInputValue);
                  } else {
                    setSearch('');
                  }
                }}
                className="cursor-pointer"
              />
            )}
          />
        </div>
        <div className='relative input'>
          <input className='input-secondary' placeholder='Membership ID' readOnly value={atcProduct?.pos_membership_product ?? ''} />
          <IdentificationIcon className='input-icon w-5 h-5' strokeWidth={1.5} />
        </div>
        <div className='flex flex-wrap items-center justify-between'>
          <h5 className='font-semibold'>Select Transaction Type</h5>
          {razorPayKeyId && (
            <>
              <label className='flex items-center gap-1 text-sm font-medium info-text cursor-pointer select-none'>
                <input type='checkbox' className='w-[17px] h-[17px] bg-secondary' onChange={handleSplitOption} />
                Split Payment Options
              </label>
            </>
          )}
        </div>
        <div
          className={`grid fill-tab ${razorPayKeyId ? "grid-cols-2" : "grid-cols-1"
            } bg-active rounded-full border min-h-[60px] border-active`}
        >
          <button
            type='button'
            onClick={() => setTab('Cash')}
            className={`tab-item cursor-pointer ${tab === "Cash" && 'active'}`}
          >
            Cash
          </button>

          {razorPayKeyId && (
            <button
              type='button'
              disabled={atcProduct?.split_payment && atcProduct?.cash_amount <= 0}
              onClick={() => setTab('UPI')}
              className={`tab-item ${atcProduct?.split_payment && atcProduct?.cash_amount <= 0
                ? 'cursor-not-allowed opacity-50'
                : 'cursor-pointer'
                } ${tab === "UPI" && 'active'}`}
            >
              UPI
            </button>
          )}
        </div>
        {/* <div className='grid fill-tab grid-cols-2 bg-active rounded-full border min-h-[60px] border-active'>
          <button type='button' onClick={() => setTab('Cash')} className={`tab-item cursor-pointer ${tab === "Cash" && 'active'}`}>Cash</button>
          <button type='button' disabled={atcProduct?.split_payment && atcProduct?.cash_amount <= 0} onClick={() => setTab('UPI')} className={`tab-item ${atcProduct?.split_payment && atcProduct?.cash_amount <= 0 ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${tab === "UPI" && 'active'}`}>UPI</button>
        </div> */}
        <div className='gap-1 promo-discount'>
          <Autocomplete
            className='autocomplete w-full'
            options={discountData}
            getOptionLabel={(options) => options?.coupon_code || ''}
            value={allDiscount?.data?.records?.find((x) => x?.coupon_code === atcProduct?.coupon_code) || null}
            onChange={handleDiscount}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder='Select Coupon'
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                className='cursor-pointer'
                onChange={(e) => {
                  const newInputValue = e.target.value;
                  if (typeof newInputValue === 'string' && newInputValue.length >= 3) {
                    setCouponSearch(newInputValue);
                  } else {
                    setCouponSearch('');
                  }
                }}
              />
            )}
            renderOption={(props, option) => (
              <Box
                key={option.code}
                component='li'
                {...props}
              >
                <div>
                  <p className='text-sm'>{option.coupon_code}</p>
                  <p className='text-sm'>{`Flat ${option?.discount} ${option?.discount_Type === 'percentage' ? '%' : GetCurrencySymbol(staffInfo?.client)} off`}</p>
                </div>
              </Box>
            )}
          />
          <button
            className={`${!selectCustomer || atcProduct?.products?.length === 0 || atcProduct?.total_discount > 0 ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} flex items-center justify-center px-1 py-1.5 w-[125px] h-[30px] text-nowrap bg-[#1E8471] rounded-3xl`}
            disabled={!selectCustomer || atcProduct?.products?.length === 0 || atcProduct?.total_discount > 0}
            onClick={() => dispatch(applyDiscount(selectCustomer, selectCoupon))}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
            </svg>
            <span className="font-semibold text-xs text-white">Apply Code</span>
          </button>
        </div>
        <div className='flex items-center'>
          <div className='relative'>
            <select className='discount-select' value={discountType} onChange={handleDiscountType} name='discount_Type'>
              <option value={'amount'}>{GetCurrencySymbol(staffInfo?.client)}</option>
              <option value={'percentage'}>%</option>
            </select>
            <div className='select-arrow'></div>
          </div>
          <input type='number' className='ml-1 w-full' placeholder='Discount Off' value={adjustDiscount} onChange={discountOff} />
        </div>
        <div className='bg-secondary p-5 rounded-[10px]'>
          <div className="space-y-1 5">
            <div className='flex items-center justify-between'>
              <span className='info-text font-medium'>Items</span>
              <span className='font-semibold'>{atcProduct?.products?.reduce((total, product) => total + product.quantity, 0)}</span>
            </div>
            <div className='flex items-center justify-between'>
              <span className='info-text font-medium'>Sub Total</span>
              <span className='font-semibold'>{FormatAmount(atcProduct?.goodsValue, staffInfo?.client)}</span>
            </div>
            {atcProduct?.pos_membership_discount > 0 && <div className='flex items-center justify-between'>
              <span className='info-text font-medium'>Membership  Discount</span>
              <span className='font-semibold'>- {FormatAmount(atcProduct?.pos_membership_discount, staffInfo?.client)}</span>
            </div>}
            {atcProduct?.total_discount > 0 && <div className='flex items-center discount-text justify-between'>
              <span className='font-medium'>Discount Applied</span>
              <span className='font-semibold'>- {FormatAmount(atcProduct?.total_discount, staffInfo?.client)}</span>
            </div>}
            {atcProduct?.adjust_discount > 0 && <div className='flex items-center discount-text justify-between'>
              <span className='font-medium'>Adjust Discount</span>
              <span className='font-semibold'>- {FormatAmount(atcProduct?.adjust_discount, staffInfo?.client)}</span>
            </div>}
            <div className='flex items-center error-text justify-between'>
              <span className='font-medium'>Tax</span>
              <span className='font-semibold'>{`+ ${FormatAmount(atcProduct?.tax_amount, staffInfo?.client)}`}</span>
            </div>
          </div>
          <hr className='border border-dashed my-3 border-color border-5' />
          <div className='flex items-center justify-between'>
            <span className='font-medium info-text'>TOTAL</span>
            <span className='font-semibold'>{FormatAmount(atcProduct?.total_price, staffInfo?.client)}</span>
          </div>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <div>
            <span className='block mb-4 text-[18px] font-semibold'>Received Cash</span>
            <div className='relative input'>
              <input type='number' className='input-secondary' value={cash} placeholder='Amount' onChange={handleCashAmount} />
              <CalculatorIcon className='input-icon w-5 h-5' />
            </div>
          </div>
          <div>
            <span className='block mb-4 text-[18px] font-semibold'>{!atcProduct?.remaining_price > 0 ? "Change Cash" : "Split Amount"}</span>
            <div className='relative input'>
              <input className='input-secondary' placeholder='Amount' readOnly value={!atcProduct?.remaining_price > 0 ? FormatAmount(atcProduct?.change_amount, staffInfo?.client) : FormatAmount(atcProduct?.remaining_price, staffInfo?.client)} />
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="input-icon w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
              </svg>
            </div>
          </div>
        </div>
        <button
          type='button'
          disabled={(tab === 'UPI' && atcProduct?.split_payment && atcProduct?.total_price === atcProduct?.cash_amount) || (!atcProduct?.split_payment && atcProduct?.cash_amount < atcProduct?.total_price)}
          className={`success-btn ${(tab === 'UPI' && atcProduct?.split_payment && atcProduct?.total_price === atcProduct?.cash_amount) || (!atcProduct?.split_payment && atcProduct?.cash_amount < atcProduct?.total_price) ? 'cursor-not-allowed opacity-50' : ''}`}
          onClick={placedOrder}
        >
          Pay Now
        </button>
      </div>
      {
        isRazorPay && razorPayData ? <PaymentRazor data={razorPayData} closeRazorpayPopup={closeRazorpayPopup} handleClosePopup={handleClosePopup} razorPayKeyid={razorPayKeyId} setIsSuccess={setIsSuccess} /> : <></>
      }
      <Popup showPopup={isSuccess} closePopup={paymentClose} callComponant={<PaymentSuccess orderData={orderData} setIsSuccess={setIsSuccess} />} closebtn={true} />
    </>
  )
}

export default PaymentDetails